import { useTranslation } from 'react-i18next';

import HttpCodePage from '../components/HttpCodePage';
import Illustration from './Illustration';

export default () => {
  const { t } = useTranslation();

  return (
    <HttpCodePage code="403" label={t('http.403.title')}>
      <Illustration />
    </HttpCodePage>
  );
};
